<template>
<div>
<ContentHeader title="Yeni Denetleme Günü Soru Listesi"  url="FlowAuditDay" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<form @submit.prevent="submitForm" class="mt-4">

<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>

<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>
</form>



</div>	
</template>

<script>
export default {

  name: 'FlowAuditdayNewQuestionlist',

  data () {
    return {
    	loading:true, 
    	item:null,
    	fields:[
      {
        title:"İsim",
        key:"name",
        type:"text",
        value:null,
        min_length:2,
        max_length:50,
        is_required:true,
        has_error:false,
        error_message:null,
        show:true,
      },
      ],   	

    }
  },
  methods:{
  	 submitForm()
    {
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
     inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false     
    },
    submit()
    {         
      this.submitting = true
      let formdata = this.createFormData(this.fields)
      formdata.append("auditday_id",this.$route.params.auditday_id)  
      //console.log(this.$route.params.id)
      this.generalSubmission(formdata,"auditday/store_questionlist",this.afterSubmit)
    },
    afterSubmit(response)
    {
         
        this.$router.push({ name: 'Questionlist', params: { id:response.data.id } })  
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>